/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import Article from '../Article';

const classNames = require('classnames');

const Proctortrack = ({ children }) => {
  const className = classNames({
    proctortrack: true
  });

  return (
    <div className={className}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <img
              // eslint-disable-next-line global-require
              src={require('./image.png')}
              alt="Linguaskill"
              style={{ maxHeight: '100%', width: '100%' }}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Article>
              <header className="article__header">
                <h2>About Proctortrack</h2>
              </header>
              <section className="article__section">
                <p>
                  Edvice has partnered with the world’s most advanced proctoring solution provider
                  leveraging automation and live proctoring using AI to deliver innovation, quality
                  and price leadership at scale.
                </p>
                <a className="button --red --basic" href="/contact">
                  Register your interest
                </a>
              </section>
              {/* <footer className="article__footer">
                <a className="button --red --basic" href="/" target="_blank">
                  Learn more
                </a>
              </footer> */}
            </Article>
          </div>
        </div>
      </div>
    </div>
  );
};
Proctortrack.defaultProps = {
  children: null
};
Proctortrack.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default Proctortrack;
